module.exports = "/assets/6fb700235c4a4ccb9c9c9fcc66e10776.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2B.png
// module id = 2108
// module chunks = 0